var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "cost-unit-edit-modal",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            size: "xl",
            title: "Schadenposition bearbeiten",
            visible: _vm.isModalOpen,
          },
          on: {
            hide: function ($event) {
              return _vm.hideReset()
            },
            show: _vm.loadForm,
          },
        },
        [
          _c(
            "div",
            { staticClass: "record-cost-unit-edit-modal" },
            [
              _c(
                "csp-desktop-info-card",
                {
                  ref: "costUnitInfoCard",
                  attrs: {
                    cols: 12,
                    "form-context": _vm.formContext,
                    icon: "inticon-users",
                    title: "Kunde",
                  },
                  on: {
                    "cancel-form": _vm.reset,
                    save: _vm.saveCostUnitFormData,
                  },
                },
                [
                  _c("csp-record-detail-cost-unit-basedata", {
                    attrs: {
                      "form-context": _vm.formContext,
                      "hide-for-group-options": _vm.hideForGroupOptions,
                      "record-id": _vm.recordId,
                    },
                  }),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("h2", [_vm._v("Zahlungen")]),
                  _vm._v(" "),
                  _vm._l(
                    _vm.formContext.form.getSubformIdentifiers(),
                    function (subformIdentifier) {
                      return _c(
                        "b-row",
                        { key: subformIdentifier, staticClass: "mt-3" },
                        [
                          _c("csp-desktop-info-card-element", {
                            staticClass: "col-5",
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "Art der Zahlung",
                              "options-loader": () =>
                                _vm.loadPaymentTypeOptions(subformIdentifier),
                              property: "paymentType",
                              required: true,
                              "subform-identifier": subformIdentifier,
                              type: "autocomplete",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.handlePaymentTypeChange(
                                  subformIdentifier
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("csp-desktop-info-card-element", {
                            staticClass: "col-2",
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "Bezahlt am",
                              property: "datePaid",
                              required: true,
                              "subform-identifier": subformIdentifier,
                              type: "datepicker",
                            },
                          }),
                          _vm._v(" "),
                          _c("csp-desktop-info-card-element", {
                            staticClass: "col-2",
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "Betrag",
                              property: "amount",
                              required: true,
                              "subform-identifier": subformIdentifier,
                              type: "currency",
                            },
                          }),
                          _vm._v(" "),
                          _c("csp-desktop-info-card-element", {
                            staticClass: "col-3",
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "Bemerkung",
                              property: "description",
                              "subform-identifier": subformIdentifier,
                              type: "text",
                            },
                          }),
                        ],
                        1
                      )
                    }
                  ),
                  _vm._v(" "),
                  !_vm.transientPaymentAdded
                    ? _c(
                        "b-row",
                        {
                          staticClass: "mt-2 mb-5",
                          attrs: { "no-gutters": "" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "col-12",
                              attrs: { size: "sm", variant: "primary" },
                              on: { click: _vm.addPayment },
                            },
                            [
                              _vm._v(
                                "\n                        Zahlung hinzufügen\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }